import { render, staticRenderFns } from "./SubmittedForm.vue?vue&type=template&id=42f23211&scoped=true&"
import script from "./SubmittedForm.vue?vue&type=script&lang=js&"
export * from "./SubmittedForm.vue?vue&type=script&lang=js&"
import style0 from "./SubmittedForm.vue?vue&type=style&index=0&id=42f23211&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f23211",
  null
  
)

export default component.exports